<template>

  <div>

    <div v-if="!selectedOrder" id="orders-list">
      <OrkLoader :loading="loading">

        <div v-if="customerOrders.length>0">
          <div class="navbar__main">
            <div class="navbar__sort">
              <span class="navbar__label">{{ $t('Sort by') }}:</span>
              <SfSelect
                  :value="sortBy.selected"
                  class="navbar__select color-primary"
                  @input="changeSorting"
              >
                <SfSelectOption
                    v-for="option in sortBy.options"
                    :key="option.id"
                    :value="option.id"
                    class="sort-by__option"
                >
                  {{ $t(option.value) }}
                </SfSelectOption>
              </SfSelect>

            </div>


          </div>

          <SfTable id='orders' class="desktop-only">
            <SfTableHeading>
              <SfTableHeader
                  v-for='tableHeader in tableHeaders'
                  :key='tableHeader'
              >{{ $t(tableHeader) }}
              </SfTableHeader>
              <SfTableHeader class='orders__element--right'>
                <span></span>
              </SfTableHeader>
            </SfTableHeading>

            <SfTableRow v-for='order in customerOrders' :key="order.reference">
              <SfTableData>
                <span class="orderLink" @click="selectOrder(order.reference)">{{ order.reference }}</span>
              </SfTableData>
              <SfTableData>
                <span class="orderLink"
                      @click="selectOrder(order.reference)">{{ $d(new Date(order.paymentDate), 'short') }}</span>
              </SfTableData>
              <SfTableData>
                <span class="orderLink" @click="selectOrder(order.reference)">
                  <span v-if="order.discountPrice.taxIncluded">{{
                      $n(order.discountPrice.taxIncluded, 'currency')
                    }}</span>
                  <span v-else>{{ $n(order.totalPrice.taxIncluded, 'currency') }}</span>
                </span>
              </SfTableData>
              <SfTableData>
                <span class="orderLink" @click="selectOrder(order.reference)">  <span :class="'color-'+order.orderState"
                                                                                      class="bold">  {{
                    status[order.orderState]
                  }}</span></span>
              </SfTableData>
              <SfTableData class='orders__view orders__element--right'>
<span>
                <SfIcon :icon="icons.show.path" :view-box="icons.show.viewBox" size="24px"
                        @click="selectOrder(order.reference)"/>
</span>
              </SfTableData>
            </SfTableRow>

          </SfTable>
          <div id="ordersMobile" class="smartphone-only">
            <div v-for='order in customerOrders' :key="order.reference" class="order"
                 @click="selectOrder(order.reference)">
              <div>{{ $t('Reference') }} : {{ order.reference }}</div>
              <div>{{ $t('Date') }} : {{ $d(new Date(order.paymentDate), 'short') }}</div>
              <div>{{ $t('Amount') }} : {{ $n(order.totalPrice.taxIncluded, 'currency') }}</div>
              <div>
                {{ $t('Status') }} : <span :class="'color-'+order.orderState" class="bold">{{
                  status[order.orderState]
                }}</span>
              </div>
              <div class='orders__view orders__element--right'>
<span>
                <SfButton class="sf-button--text color-primary"
                          @click="selectOrder(order.reference)">{{ $t('Show detail') }}</SfButton>
</span>
              </div>
            </div>
          </div>
          <SfPagination
              v-show="pagination.totalPages > 1"
              :current="pagination.currentPage"
              :total="pagination.totalPages"
              :visible="5"
              class="products__pagination"
          />
        </div>
        <div v-else class="no-orders">
          <div class="no-orders-content">

            <p class="description">{{ $t('No order yet') }}</p>
            <SfButton class="color-primary" link="/">{{ $t('Start my shopping') }}</SfButton>
          </div>
        </div>
      </OrkLoader>
    </div>

    <div v-else id="order">

      <SfButton class="sf-button--text return color-primary" @click="backToOrder()">
        <SfIcon :icon="icons.left.path" :view-box="icons.left.viewBox"
                size="16px"></SfIcon>
        {{
          $t('myOrders.order.backToOrdersList')
        }}
      </SfButton>

      <div class="header-order">
        <div class="header-order-content">
          <h2 class="header-order-content-ref">
            {{ $t('myOrders.order.header.orderDetails', {ref: selectedOrder.reference}) }}</h2>
          <p class="header-order-content-date">{{ $t('myOrders.order.header.from') }} {{
              $d(new Date(selectedOrder.paymentDate), 'long')
            }}</p>

        </div>

        <SfButton v-if="selectedOrder.orderState==='COMPLETED'" class="download" @click="downloadInvoice">{{ $t('myOrders.order.header.downloadBill') }}</SfButton>
      </div>

      <div class="your-order">
        <h2>{{ $t('myOrders.order.yourOrder.title') }}</h2>

        <div v-for="(shipment,i) in selectedOrder.shipments" :key="i" class="products-list">

          <SfHeading :level="3" :title="'Expedition ' + (i+1) +' sur ' + selectedOrder.shipments.length"
                     class="shipment-title"></SfHeading>
          <div class="shipment">
            <div v-for="item in shipment.items" :key="item.product.reference" class="product"
                 @click="goProduct(item.product.slug)">
              <div class="product-img">
                <SfImage :alt="item.product.cover.title" :src="item.product.cover.src||''"
                         height="110" placeholder="/assets/images/placeholder.webp" width="110"
                ></SfImage>
              </div>
              <div class="product-information">
                <div>
                  <h3 class="title" @click="goProduct(item.product.slug)">{{ item.product.name }}</h3>
                  <span v-if="item.product.reference" class="ref">{{ $t('sku') }} : {{ item.product.reference }}</span>
                  <span v-else class="ref">{{ $t('sku') }} : {{ item.product.reference }}</span>
                  <div v-if="item.product.selectedAttributes && Object.keys(item.product.selectedAttributes).length > 0"
                       class="product-configurables-attr">
                    <div
                        v-for="attr in item.product.selectedAttributes"
                        :key="attr"
                        class="configurables-attr">
                      <p>{{ attr.label }} :</p>

                      <div v-if="attr.displayType === 'TEXT'">
                        <b> {{ attr.value }}</b>
                      </div>
                      <div v-if="attr.displayType === 'COLOR'"
                           :style="{'background': attr.value}"
                           class="attr-color">
                      </div>
                    </div>
                  </div>
                  <div class="price-unit">
                    <span class="label">{{ $t('Unit price ') }} :</span>

                    <SfPrice
                        :regular="$n(item.unitPrice.regular, 'currency')"
                        :special="item.unitPrice.discount && $n(item.unitPrice.discount,'currency')"/>
                  </div>
                </div>
                <p class="product-quantity">{{ $t('myOrders.order.yourOrder.quantity', {qty: item.quantity}) }}</p>
              </div>

              <OrkPrice :regular="$n(item.price.taxIncluded, 'currency') | toCurrency" class="price"></OrkPrice>

            </div>
            <div class="shipment-description">
              <div class="shipment-description-title">{{ shipment.shipmentMethod.name }}</div>
              <div class="shipment-description-delivery">

                <span v-if="shipment.shipmentMethod.deliveryTimeUnit === 'DAYS'">
                {{ $tc('deliveryTime.day', shipment.shipmentMethod.deliveryTime) }}
                </span>
                <span v-else-if="shipment.shipmentMethod.deliveryTimeUnit === 'HOURS'">
                   {{ $tc('deliveryTime.hour', shipment.shipmentMethod.deliveryTime) }}
                </span>
              </div>
              <div v-if="shipment.shipmentMethod.price.taxIncluded > 0" class="shipment-description-price">
                <OrkPrice :regular="$n(shipment.shipmentMethod.price.taxIncluded, 'currency') | toCurrency"
                          class="price"></OrkPrice>
              </div>
              <div v-else class="shipment-description-price">
                {{ $t('free') }}
              </div>


            </div>
          </div>
        </div>

        <hr>

        <div class="price-details">
          <div class="price-line">
            <p>{{ $t('myOrders.order.priceDetails.shippingMethod') }}</p>
            <p>{{ $n(selectedOrder.shippingPrice.taxIncluded, 'currency') }}</p>
          </div>
          <div class="price-line">
            <p>{{ $t('myOrders.order.priceDetails.totalHT') }}</p>
            <p>{{ $n(selectedOrder.totalPrice.taxFree-selectedOrder.shippingPrice.taxIncluded, 'currency') }}</p>
          </div>
          <div v-if="selectedOrder.discountPrice.taxIncluded" class="price-line">
            <p>{{ $t('myOrders.order.priceDetails.totalTaxe') }}</p>
            <p>{{ $n(selectedOrder.totalPrice.taxIncluded, 'currency') }}</p>
          </div>
          <div v-if="selectedOrder.discountPrice.taxIncluded" class="price-line bold">
            <p>{{ $t('myOrders.order.priceDetails.discount') }} {{ getCouponCode(selectedOrder.coupon) }}</p>
            <p>{{
                $n((selectedOrder.discountPrice.taxIncluded - selectedOrder.totalPrice.taxIncluded), 'currency')
              }}</p>
          </div>
          <div class="price-line">
            <p>{{ $t('myOrders.order.priceDetails.taxe') }} ({{ selectedOrder.shippingAddress.country }})</p>
            <p v-if="selectedOrder.discountPrice.taxIncluded">{{
                $n(selectedOrder.discountPrice.taxAmount, 'currency')
              }}</p>
            <p v-else>{{ $n(selectedOrder.totalPrice.taxAmount, 'currency') }} </p>
          </div>
          <div class="price-line">
            <p>{{ $t('myOrders.order.priceDetails.totalTaxe') }}</p>
            <p v-if="selectedOrder.discountPrice.taxIncluded">{{
                $n(selectedOrder.discountPrice.taxIncluded, 'currency')
              }}</p>
            <p v-else>{{ $n(selectedOrder.totalPrice.taxIncluded, 'currency') }}</p>
          </div>
        </div>
      </div>
      <div class="details-order">

        <div v-if="selectedOrder.shippingAddress" class="detail">
          <h3>{{ $t('myOrders.order.detailsOrder.shippingAddress') }}</h3>
          <user-address :address="selectedOrder.shippingAddress"
                        :isRelais="!selectedOrder.shippingAddress.name.search('relay')"
                        :show-address-name="false"></user-address>

        </div>
        <div v-if="selectedOrder.billingAddress" class="detail">
          <h3>{{ $t('myOrders.order.detailsOrder.billingAddress') }}</h3>
          <user-address :address="selectedOrder.billingAddress" :show-address-name="false"></user-address>

        </div>
        <div v-if="selectedOrder.billingDetails" class="detail">
          <h3>{{ $t('myOrders.order.detailsOrder.payment') }}</h3>
          <div class="payment-details">
            <p>{{ $t('myOrders.order.detailsOrder.reference') }}{{ selectedOrder.billingDetails.transactionNumber }}</p>
            <p>{{ $t('myOrders.order.detailsOrder.date') }}{{ $d(new Date(selectedOrder.paymentDate), 'short') }}</p>
            <p>
              {{ $t('myOrders.order.detailsOrder.paymentMethod') }}{{ $t(selectedOrder.billingDetails.paymentMethod) }}
            </p>
            <p v-if="selectedOrder.discountPrice.taxIncluded">
              {{ $t('myOrders.order.detailsOrder.amount') }}{{
                $n(selectedOrder.discountPrice.taxIncluded, 'currency')
              }}
            </p>
            <p v-else>
              {{ $t('myOrders.order.detailsOrder.amount') }}{{ $n(selectedOrder.totalPrice.taxIncluded, 'currency') }}
            </p>
          </div>
        </div>
      </div>
      <div class="shipmentOrder">
        <div class="shipmentOrder__content">

          <h2>{{ $t('myOrders.order.shippmentOrder.title') }}</h2>

          <table>
            <tr v-for="event in Object.keys(selectedOrder.eventHistory)" :key="event">
              <td>{{ eventHistoryStatus[event].title }}</td>
              <td>{{ $d(new Date(selectedOrder.eventHistory[event].date), 'short') }}</td>
              <td>
                {{ eventHistoryStatus[event].description }}
                <p v-for="tracking in selectedOrder.eventHistory[event].trackings" :key="tracking" style="margin: 0">
                  <a v-if="tracking.url" :href="tracking.url">
                    {{ $t('myOrders.order.eventHistory.followPackage') }} {{ tracking.number }}
                  </a>
                </p>
              </td>
              <td>
                <SfIcon :icon="icons.check.path" :view-box="icons.check.viewBox" class="icon" size="1.2rem"/>
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import {
  SfButton, SfIcon, SfPagination, SfSelect, SfImage, SfTable, SfPrice, SfHeading
} from '@storefront-ui/vue';
import icons from "@/utils/icons";
import Api from "@/api/Api";
import UserAddress from "@/components/UserAddress";
import {Pagination} from "@/models/pagination";
import OrderOptions from "@/utils/order_options";
import OrkLoader from "@/components/Ork/OrkLoader";
import {Order} from "@/models/order";
import OrkPrice from "@/components/Ork/OrkPrice";


export default {
  name: "MyOrders",
  metaInfo: {
    title: 'Trinitas',
    titleTemplate: '%s | OrderInformations ',
    meta: [
      {name: 'Description ', content: 'bar'}
    ]
  },
  components: {
    OrkPrice,
    SfTable,
    OrkLoader,
    UserAddress,
    SfPrice,
    SfButton,
    SfIcon,
    SfPagination,
    SfSelect,
    SfImage,
    SfHeading
  },
  data() {
    return {
      loading: false,
      pagination: Pagination.of(null),
      sortBy: {options: OrderOptions.getOrderOptions.sortAttributes, selected: 'paymentDate.desc'},
      sortOption: OrderOptions.getOrderOptions.sortAttributes,
      icons: icons,
      status: {
        CANCELLED: this.$i18n.t('CANCELLED'),
        COMPLETED: this.$i18n.t('COMPLETED'),
        PROCESSING: this.$i18n.t('PROCESSING'),
        SHIPPED: this.$i18n.t('SHIPPED'),
        PAYMENT_FAILED: this.$i18n.t('PAYMENT FAILED')
      },
      eventHistoryStatus: {
        PAYMENT_FAILED: {
          title: this.$i18n.t('myOrders.order.eventHistory.paymentFailed.title'),
          description: this.$i18n.t('myOrders.order.eventHistory.paymentFailed.description'),
        },
        CANCELLED: {
          title: this.$i18n.t('myOrders.order.eventHistory.cancelled.title'),
          description: this.$i18n.t('myOrders.order.eventHistory.cancelled.description'),
        },
        COMPLETED: {
          title: this.$i18n.t('myOrders.order.eventHistory.completed.title'),
          description: this.$i18n.t('myOrders.order.eventHistory.completed.description'),
        },
        PROCESSING: {
          title: this.$i18n.t('myOrders.order.eventHistory.processing.title'),
          description: this.$i18n.t('myOrders.order.eventHistory.processing.description'),
        },
        SHIPPED: {
          title: this.$i18n.t('myOrders.order.eventHistory.shipped.title'),
          description: this.$i18n.t('myOrders.order.eventHistory.shipped.description'),
        },
      },
      tableHeaders: [
        'Reference',
        'Date',
        'Amount',
        'Status'
      ],
      customerOrders: [],
      selectedOrder: null,
      Order: Order
    };
  },

  computed: {
    configurablesAttributes: {
      get(attrs) {
        return Object.keys(attrs).sort((a, b) => {

          return attrs[a].label < attrs[b].label ? -1 : 1;
        })
      }
    }
  },
  mounted() {
    this.getCustomerOrders();
  },
    watch: {
        $route: 'getCustomerOrders'
    },
  methods: {
    getCouponCode(coupon) {
      if (coupon) {
        return coupon.code
      }
    },
    goProduct(slug) {
      this.$router.push('/produit/' + slug);
    },
    downloadInvoice() {
      this.selectedOrder.id
      Api.order.getInvoice(this.selectedOrder.id).then((data) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "trinitas-" + this.selectedOrder.reference + ".pdf"); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).catch((e) => {
      }).finally(() => {
        this.loading = false;
      })
    },
    selectOrder(orderReference) {
      this.selectedOrder = this.customerOrders.filter(order => order.reference === orderReference)[0];
      this.$router.replace({
        query: {order: orderReference}
      });
    },
    backToOrder() {
      this.$router.replace({
        query: {}
      });
      this.selectedOrder = null;
    },
      
    getCustomerOrders() {
      this.loading = true;
      this.customerOrders = [];
      Api.order.getCustomerOrders(this.$router.history.current.query).then((data) => {

        this.pagination = Pagination.of(data);

        for (const order of data.content) {
          this.customerOrders.push(Order.of(order));
        }

        if (this.$router.history.current.query.order) {
          this.selectOrder(this.$router.history.current.query.order)
        }

      }).catch((e) => {
          // console.error(e)
      }).finally(() => {
        this.loading = false;
      })
    },
    changeSorting(sort) {
      this.sortBy.selected = sort;
      OrderOptions.changeSorting(sort);
    },
    changeItemsPerPage(itemsPerPage) {
      this.pagination.itemsPerPage = itemsPerPage;
      OrderOptions.changeItemsPerPage(itemsPerPage);
    },
  },

}
</script>

<style lang="scss" scoped>

h1, h2, h3 {
  line-height: normal !important;
}

.shipment-description {
  background-color: var(--_c-primary-sidebar);
  margin: var(--spacer-xs) 0 0;
  padding: var(--spacer-sm);
  display: flex;
  flex-wrap: wrap;

  &-title {
    flex: 1;
    font-size: var(--font-size--lg);
  }

  &-description {
    flex: 1;
    font-size: var(--font-size--sm);
  }

  &-price {
    font-size: var(--font-size--lg);
    font-weight: bold;
    flex: 1;
    text-align: right;
    font-family: var(--font-family--secondary);

    ::v-deep {
      .price.sf-price {
        .sf-price__regular {
          font-size: var(--font-size--xl) !important;
          font-weight: bold;
          flex: 1;
          text-align: right;
          font-family: var(--font-family--secondary);
        }
      }
    }
  }
}
.shipment{
  margin-top: var(--spacer-base);
  border: 1px solid var(--_c-lightgray);

  &-title{

  }


}
#orders-list {
  display: flex;
  flex-direction: column;
}

.no-orders {
  display: block;
  width: 100%;
  margin: var(--spacer-2xl) auto 0;

  .description {
    text-align: center;
    font-weight: bold;
    font-size: var(--font-size--lg);
  }

  &-content {
    display: flex;
    align-items: center;
    justify-content: stretch;
    flex-direction: column;
    width: 100%;

    .sf-button {
      width: 50%;
      margin: var(--spacer-2xl) auto 0;
    }
  }
}

#orders {
  width: 100%;
  border-collapse: collapse;

  tbody {
    ::v-deep {
      .sf-table__row {
        background-color: var(--c-white);
      }
    }

    &:nth-child(odd) {
      ::v-deep {
        .sf-table__row {
          background-color: var(--_c-lightgray);
        }
      }
    }
  }

  .sf-table__data, .sf-table__header {
    &.orders__element--right {

      ::v-deep {
        .sf-icon {
          cursor: pointer;
          --icon-color: var(--c-primary);

          &:hover {
            --icon-color: var(--c-primary);
          }
        }

        > span {
          display: block;
          width: 32px;
        }
      }
    }

    &:last-of-type {
      flex: 0;
      width: 32px;
    }

    span {
      color: var(--c-text);

      &.bold {
        font-weight: bold;
      }

      &.color-PAYMENT_FAILED {
        color: var(--c-danger);
      }

      &.color-CANCELLED {
        color: var(--c-danger);
      }

      &.color-COMPLETED {
        color: var(--c-success);
      }

      &.color-SHIPPED {
        color: var(--c-success);
      }

      &.color-PROCESSING {
        color: var(--c-warning);
      }
    }
  }

  ::v-deep {
    .sf-table__row {
      box-shadow: none !important;

      &:hover {
        box-shadow: none !important;
      }

      &:last-child .sf-table__data {
        border: none;
      }
    }
  }

}

#ordersMobile {
  display: flex;
  grid-template-columns: repeat(3, 1fr);
  flex-wrap: wrap;
  gap: var(--spacer-base);
  @include for-mobile {
    gap: var(--spacer-sm);

    grid-template-columns: none;
  }

  .order {
    flex: auto;
    border: 1px solid var(--_c-primary-background);
    border-radius: 2px;
    display: block;
    box-shadow: 0 5px 10px -5px rgb(0 0 0 / 10%);
    transition: 0.2s ease box-shadow;
    padding: var(--spacer-sm);

    span {
      color: var(--c-text);

      &.bold {
        font-weight: bold;
      }

      &.color-CANCELLED {
        color: var(--c-danger);
      }

      &.color-COMPLETED {
        color: var(--c-success);
      }

      &.color-PROCESSING {
        color: var(--c-warning);
      }
    }

    &:hover {
      box-shadow: 0 5px 20px -10px rgb(0 0 0 / 20%);
    }
  }
}

#order {
  .header-order {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    padding: var(--spacer-lg) var(--spacer-xs);
    border-top: 1px solid var(--c-primary);
    border-bottom: 1px solid var(--c-primary);

    &-content {
      &-ref {
        font-size: calc(var(--font-size--lg) * 1.25);
        text-transform: uppercase;
      }

      &-date {
        color: var(--c-gray);
        text-transform: none;
        font-size: var(--font-size--base);
        font-weight: normal;
        margin: 0;
      }
    }

    @include for-mobile {
      flex-direction: column;

      &-content {
        width: 100%;

        &-date {
          display: flex;
          flex-direction: column;
        }
      }
    }


    .sf-button {
      padding: var(--spacer-sm) var(--spacer-sm);
      max-height: 40px;

      @include for-mobile {
        margin-top: var(--spacer-sm);
      }
    }
  }

  .return {
    margin-bottom: var(--spacer-xs);

    .sf-icon {
      --icon-color: var(--c-primary);
    }

    &:hover {
      text-decoration: underline;
    }
  }

  .your-order {
    h2 {
      padding: var(--spacer-sm) var(--spacer-xs);
      font-size: 1.4rem;
      text-transform: uppercase;
    }

    .products-list {
      padding: var(--spacer-base) 0;

      .product {
        cursor: pointer;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: var(--spacer-sm);
        margin: var(--spacer-base) var(--spacer-base);
        background-color: white;
        box-shadow: 0 5px 20px -7px rgba(0, 0, 0, 0.1);
        transition: 0.2s ease box-shadow;

        &:hover {
          box-shadow: 0 5px 20px -7px rgba(0, 0, 0, 0.25);
        }

        .product-img {
          display: flex;
          margin-right: var(--spacer-sm);
          min-width: 110px;
          max-width: 110px;
          min-height: 110px;
          max-height: 110px;
          align-self: center;
          align-items: center;
          border: 5px solid white;
          background: transparent;


          ::v-deep {
            .sf-image {
              width: 100%;
            }
          }
        }

        .product-information {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .product-configurables-attr {
            display: flex;
            flex-wrap: wrap;

            .configurables-attr {
              display: flex;
              border-right: 1px solid grey;
              max-height: 1.3rem;
              padding-right: var(--spacer-xs);
              margin-right: var(--spacer-xs);
              font-weight: 400;

              p {
                margin-right: 5px;
              }

              .attr-color {
                width: 15px;
                height: 15px;
                padding: 0;
                border-radius: 2px;
                border: 2px solid white;
                box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 38%);
              }
            }

            div:last-child {
              border: none;
              padding-right: 0;
            }
          }

          p {
            margin: 0;
            font-weight: 400;
          }

          .product-quantity {
            font-size: var(--font-size--lg);
            // margin-bottom: 1rem;
          }
        }

        h3.title {
          position: relative;
          @include for-mobile {
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
          }
        }

        .price {
          align-self: end;


          &-unit {
            display: flex;
            flex-wrap: wrap;
            align-items: baseline;
            font-size: var(--font-size--sm);
            font-weight: 400;

            .label {
              margin-right: 5px;
            }

            .sf-price__regular, .sf-price__special {
              font-size: var(--font-size--sm);
              font-weight: 400;
            }
          }

          .sf-price {

            &__regular {
              font-size: calc(var(--font-size--lg) * 1.25);
              font-weight: bold;
              // position: absolute;
              // bottom: 0.5rem;
              //  right: 0.5rem;
            }
          }

        }
      }
    }

    .price-details {
      line-height: 1.3rem;
      border-bottom: 1px solid var(--c-primary);
      padding: var(--spacer-sm) var(--spacer-xs);

      .price-line {
        display: flex;
        justify-content: space-between;
        margin-top: var(--spacer-xs);

        p {

          font-weight: 400;
          margin: 0;
        }
      }

      .price-line:last-child {
        margin-top: var(--spacer-sm);

        p {
          font-weight: bold;
          font-size: 1.5rem;
        }
      }

      .bold {
        p {
          font-weight: bold;
        }
      }
    }
  }

  .details-order {
    border-bottom: 1px solid var(--c-primary);
    padding: var(--spacer-lg) var(--spacer-xs) var(--spacer-lg) 0;
    display: flex;
    align-self: stretch;
    @include for-mobile {
      flex-direction: column;
    }

    .detail {
      flex: 1;
      margin: 0 var(--spacer-xs);
      display: flex;
      flex-direction: column;
      align-self: stretch;


      h3 {
        text-transform: uppercase;
        font-size: 1rem;
        margin-bottom: var(--spacer-sm);
      }


      .user-address,
      .payment-details {
        padding: var(--spacer-sm);
        flex: 1;
        border: 1px solid var(--_c-primary-background);
        border-radius: 2px;
        display: block;
        box-shadow: 0 2px 5px -2px rgb(0 0 0 / 0%);

        p {
          color: var(--c-text);
          line-height: 1.3rem;
          font-weight: normal;
          margin: 0;
        }
      }
    }

    @include for-mobile {
      div {
        border-bottom: 1px solid grey;
        padding: var(--spacer-sm) 0;
      }

      div:last-child {
        border: none;
      }

      div:first-child {
        padding-top: 0;
      }
    }

    .user-address {
      margin: 0;
    }

    .user-address:hover {
      border: 1px solid var(--_c-primary-background);
      box-shadow: 0 2px 5px -2px rgb(0 0 0 / 0%);
    }
  }

  .shipmentOrder {
    &__content {
      margin-top: var(--spacer-base);
      padding: 0 var(--spacer-xs);
    }

    h2 {
      margin-top: var(--spacer-base);
      font-size: 1.4rem;
      text-transform: uppercase;
      margin-bottom: var(--spacer-sm);
    }

    .icon {
      fill: green;
    }

    table {
      width: 100%;
      font-weight: 400;

      td {
        padding-right: var(--spacer-sm);
      }

      td:last-child {
        padding-right: 0;
      }

      @include for-mobile {
        td {
          display: block;
        }
        tr {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: var(--spacer-sm);

          td:nth-child(1) {
            flex: 1 80%;
            font-weight: 500;
            order: -1;
          }

          td:nth-child(2) {
            flex: 1 100%;
            font-weight: bold;
            order: -2;
          }

          td:last-child {
            order: -1;
          }
        }
      }
    }

  }


}


.navbar {
  &__main {
    display: none !important; // TODO Remove this when sorting is enable in qorus
    // display: flex;
    align-items: center;
    flex: 1;
    justify-content: space-between;
    padding: var(--spacer-xs) 0;
  }

  &__label {
    font-family: var(--font-family--secondary);
    font-weight: var(--font-weight--normal);
    color: var(--c-text-muted);
    @include for-desktop {
      color: var(--c-link);
      margin: 0 var(--spacer-2xs) 0 0;
    }
  }

  &__select {
    --select-width: 220px;
    --select-padding: 0;
    --select-height: 42px;
    --select-selected-padding: 0 var(--spacer-lg) 0 var(--spacer-2xs);
    --select-margin: 0;
    --select-option-font-size: var(--font-size-sm);
    --select-error-message-height: 0;
    margin: 0;

    ::v-deep .sf-select__dropdown {
      color: var(--c-tertiary);
      font-size: var(--font-size-sm);
      font-family: var(--font-family--secondary);
      font-weight: var(--font-weight--normal);
      margin: 0;
    }

    ::v-deep .sf-select__placeholder {
      --select-option-font-size: var(--font-size-sm);
    }
  }

  &__sort {
    display: flex;
    align-items: center;
    // margin: 0 auto 0 var(--spacer-2xl);
    margin: var(--spacer-base) auto var(--spacer-lg) 0;
  }


}

.orderLink {
  &:hover {
    cursor: pointer;

    text-decoration: underline;
  }
}

::v-deep {
  .sf-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: var(--spacer-base);
  }
}


</style>